import React, { useState } from 'react';
import Header from '../../components/ui/Header';
import Sidebar from '../../components/ui/Sidebar';
import MetricsGrid from './components/MetricsGrid';
import QuickActions from './components/QuickActions';
import AuditActivityFeed from './components/AuditActivityFeed';
import SecurityAlertsPanel from './components/SecurityAlertsPanel';
import PasswordHealthChart from './components/PasswordHealthChart';
import UsageAnalytics from './components/UsageAnalytics';

const OrganizationDashboard = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const handleToggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <Sidebar 
        isCollapsed={sidebarCollapsed} 
        onToggleCollapse={handleToggleSidebar} 
      />
      <main className={`pt-16 transition-all duration-300 ${
        sidebarCollapsed ? 'lg:ml-16' : 'lg:ml-72'
      }`}>
        <div className="p-6 space-y-8">
          {/* Page Header */}
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-foreground">Organization Dashboard</h1>
              <p className="text-muted-foreground mt-1">
                Comprehensive overview of your organization's password security and activity
              </p>
            </div>
            <div className="text-sm text-muted-foreground">
              Last updated: {new Date()?.toLocaleString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
              })}
            </div>
          </div>

          {/* Metrics Overview */}
          <section>
            <h2 className="text-xl font-semibold text-foreground mb-4">Security Metrics</h2>
            <MetricsGrid />
          </section>

          {/* Quick Actions */}
          <section>
            <QuickActions />
          </section>

          {/* Password Health Charts */}
          <section>
            <h2 className="text-xl font-semibold text-foreground mb-4">Password Health Analysis</h2>
            <PasswordHealthChart />
          </section>

          {/* Activity and Alerts */}
          <section>
            <h2 className="text-xl font-semibold text-foreground mb-4">Real-time Monitoring</h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <AuditActivityFeed />
              <SecurityAlertsPanel />
            </div>
          </section>

          {/* Usage Analytics */}
          <section>
            <h2 className="text-xl font-semibold text-foreground mb-4">Usage Analytics</h2>
            <UsageAnalytics />
          </section>
        </div>
      </main>
    </div>
  );
};

export default OrganizationDashboard;